import {html, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {live} from 'lit/directives/live.js';
import {ExternalEmbedSettings} from '../../ts/services/externalembedsettings';

import styles from './externalembedlist.styles';
import elements from '../../ts/css/elements.styles';
import {resetStyles} from '../../ts/css/resets.styles';

@customElement('ui-externalembedlist')
export class Externalembedlist extends LitElement {
  static readonly styles = [resetStyles, elements, styles];

  @property({type: Array}) sites: string[];

  @state() private toggleAllCurrentText = '';

  private readonly externalEmbedSettings: ExternalEmbedSettings;
  private readonly storageKey = 'showExternalEmbed';
  private readonly activateAllText = 'Alle aktivieren';
  private readonly deactivateAllText = 'Alle deaktivieren';

  constructor() {
    super();
    this.externalEmbedSettings = new ExternalEmbedSettings(this.storageKey);
  }

  render() {
    this.setToggleAllBtnText();

    return html`
      <div class="externalembedlist__link">
        <a class="externalembedlist__toggleAll" @click=${this.handleToggleAllBtnClick}>${this.toggleAllCurrentText}</a>
      </div>
      ${this.renderSiteCheckboxTemplate()}
    `;
  }

  renderSiteCheckboxTemplate() {
    return this.sites
      ? this.sites.map(site => html`
        <div class="externalembedlist__item">
          <div class="externalembedlist__text">
            <span>${site}</span>
          </div>
          <div class="externalembedlist__check">
            <label class="switch animate">
              <input type="checkbox"
                     data-site=${site.toLowerCase()}
                     .checked=${live(this.externalEmbedSettings.userOpttedIn(site))}
                     @click=${this.toggleSiteCheck}>
              <span class="toggle">
              <span class="ball"></span>
              </span>
            </label>
          </div>
        </div>
      `)
      : null;
  }

  toggleSiteCheck(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const site = inputElement.dataset.site;
    const isChecked = inputElement.checked;

    this.externalEmbedSettings.optInUser(isChecked, site);
  }

  setToggleAllBtnText() {
    let anyConsents = false;

    for (const site of this.sites) {
      if (this.externalEmbedSettings.userOpttedIn(site)) {
        anyConsents = true;
        break;
      }
    }

    if (!anyConsents) {
      this.toggleAllCurrentText = this.activateAllText;
    } else {
      this.toggleAllCurrentText = this.deactivateAllText;
    }
  }

  handleToggleAllBtnClick(event: Event) {
    event.preventDefault();

    if (this.toggleAllCurrentText === this.deactivateAllText) {
      window.localStorage.removeItem(this.storageKey);
      this.toggleAllCurrentText = this.activateAllText;
    } else {
      this.sites.forEach(site => {
        this.externalEmbedSettings.optInUser(true, site);
      });
      this.toggleAllCurrentText = this.deactivateAllText;
    }
  }
}
